
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index3bjhLPnaPriR6POx5HP0qLyHdTkGMFg0DXZVLRM81pYMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/index.vue?macro=true";
import { default as index07N2JvngteOhhOR1tMw3J7svNhrcnSvFwtJHV_45dMvsoMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/cart/index.vue?macro=true";
import { default as indexcW9NtoLJrv5UTssm4dcRZiGlo8cOSc8QrNQxljAHuaIMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/login/index.vue?macro=true";
import { default as indexhuECFk15SxAVmFj8drPpRGpnq2FEbQcceEOSIC_eSZgMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/logout/index.vue?macro=true";
import { default as indexp6wPM3FCCQd1dXLb23nrUOCkQidYOaAc34dyEucmXToMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/catalog/index.vue?macro=true";
import { default as indexqkDsM2z2Aaw6q8FLkIWiZlPAMrpG2WHEqHp3A8t53i4Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/category/index.vue?macro=true";
import { default as indexBrYW0RqvE9xOw_45_7v87WpoGkUQI3koQ7McHUVatnlKgMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/checkout/index.vue?macro=true";
import { default as indexoXy9vYe1UIUrrQpoQVR_45wLNmO_457O8EeuzcpsW8cs_68Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/customer/index.vue?macro=true";
import { default as indexiTeDA5GfyOq58IfpbXC_svQ_45L9H5l2Vi11nAsNTjwz0Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/myorders/index.vue?macro=true";
import { default as indexxryOg1pr__GYX5WPJKWz38UKmwR2a5sNFgj_WXJMP_EMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/index.vue?macro=true";
import { default as resetPasswordTqYqDXV67q_g0zltjmYIYdR_45PC158eBdvV9_bVUUumAMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/user/resetPassword.vue?macro=true";
import { default as listjcy42pBsBrEa1UUjT57jZVIRV_lfoH8AOpfz_451DD4dUMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/style/list.vue?macro=true";
import { default as index5cqfKr_45Ato5O9bweG_45s8O3WJp6_16GpSJy_45bZIsO_XEMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/style/index.vue?macro=true";
import { default as _91categoryCode_93XdcstZPZ88SJkXaqL9fQHs8vXeNMbnxbL7NK3a6zpCwMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/catalog/[categoryCode].vue?macro=true";
import { default as _91categoryCode_93U_gDqwIqFE_45PDax7BB200xaNO5fL9bNC4tagtBcy3z8Meta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/category/[categoryCode].vue?macro=true";
import { default as _91productNo_93uZlDWkQ0QlqqBIpEw8d8innruUhUQX43W_tfy6TGlZoMeta } from "C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/style/[productNo].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/index.vue")
  },
  {
    name: "cart",
    path: "/cart",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/cart/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: indexcW9NtoLJrv5UTssm4dcRZiGlo8cOSc8QrNQxljAHuaIMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/login/index.vue")
  },
  {
    name: "logout",
    path: "/logout",
    meta: indexhuECFk15SxAVmFj8drPpRGpnq2FEbQcceEOSIC_eSZgMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/logout/index.vue")
  },
  {
    name: "catalog",
    path: "/catalog",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/catalog/index.vue")
  },
  {
    name: "category",
    path: "/category",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/category/index.vue")
  },
  {
    name: "checkout",
    path: "/checkout",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/checkout/index.vue")
  },
  {
    name: "customer",
    path: "/customer",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/customer/index.vue")
  },
  {
    name: "myorders",
    path: "/myorders",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/myorders/index.vue")
  },
  {
    name: "inventory",
    path: "/inventory",
    meta: indexxryOg1pr__GYX5WPJKWz38UKmwR2a5sNFgj_WXJMP_EMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/index.vue")
  },
  {
    name: "user-resetPassword",
    path: "/user/resetPassword",
    meta: resetPasswordTqYqDXV67q_g0zltjmYIYdR_45PC158eBdvV9_bVUUumAMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/user/resetPassword.vue")
  },
  {
    name: "inventory-style-list",
    path: "/inventory/style/list",
    meta: listjcy42pBsBrEa1UUjT57jZVIRV_lfoH8AOpfz_451DD4dUMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/style/list.vue")
  },
  {
    name: "inventory-style",
    path: "/inventory/style",
    meta: index5cqfKr_45Ato5O9bweG_45s8O3WJp6_16GpSJy_45bZIsO_XEMeta || {},
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/style/index.vue")
  },
  {
    name: "catalog-categoryCode",
    path: "/catalog/:categoryCode()",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/catalog/[categoryCode].vue")
  },
  {
    name: "category-categoryCode",
    path: "/category/:categoryCode()",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/category/[categoryCode].vue")
  },
  {
    name: "inventory-style-productNo",
    path: "/inventory/style/:productNo()",
    component: () => import("C:/N41VendorWeb/N41_VENDOR_WEB_SHOW/src/pages/inventory/style/[productNo].vue")
  }
]